<template>
  <div class="login-container">
    <div class="login-box">
      <h2>手机号登录</h2>
      <div class="input-group">
        <input
          type="tel"
          v-model="phone"
          placeholder="请输入手机号"
          maxlength="11"
        >
      </div>
      <button class="login-btn" @click="handleLogin" :disabled="loading">
        {{ loading ? '登录中...' : '登录' }}
      </button>
    </div>
  </div>
</template>

<script>
import toast from '@/utils/toast'
import { commonApi } from '@/api'

export default {
  name: 'Login',
  data () {
    return {
      phone: '',
      loading: false
    }
  },
  methods: {
    async handleLogin () {
      if (!this.phone || this.phone.length !== 11) {
        toast.error('请输入正确的手机号')
        return
      }

      this.loading = true
      toast.loading('登录中...')

      try {
        await commonApi.loginPhone({ phone: this.phone }).then(res => {
          toast.success('登录成功')
          localStorage.setItem('token', res.token)
          this.$router.push('/home')
        }).catch(error => {
          toast.error(error)
        })
      } catch (error) {
        toast.error('网络错误，请检查网络连接后重试')
        console.error('登录错误：', error)
      } finally {
        this.loading = false
      }
    }
  },
  created () {
    if (localStorage.getItem('token')) {
      this.$router.push('/home')
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;

  .login-box {
    width: 80%;
    max-width: 400px;
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

    h2 {
      text-align: center;
      margin-bottom: 20px;
      color: #333;
    }

    .input-group {
      margin-bottom: 20px;

      input {
        width: 100%;
        height: 40px;
        padding: 0 15px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        font-size: 14px;

        &:focus {
          outline: none;
          border-color: #409eff;
        }
      }
    }

    .login-btn {
      width: 100%;
      height: 40px;
      background-color: #409eff;
      color: #fff;
      border: none;
      border-radius: 4px;
      font-size: 16px;
      cursor: pointer;

      &:hover:not(:disabled) {
        background-color: #66b1ff;
      }

      &:disabled {
        background-color: #a0cfff;
        cursor: not-allowed;
      }
    }
  }
}
</style>
